import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  activated: {
    id: 'activated',
    defaultMessage: 'Activated',
    description: 'Locked offer has been activated',
  },
  activate: {
    id: 'activate',
    defaultMessage: 'Activate',
    description: 'Locked offer is active and ready to be activated',
  },
  details: {
    id: 'details',
    defaultMessage: 'Details',
    description: 'View details of locked offer',
  },
  redeemNow: {
    id: 'redeemNow',
    defaultMessage: 'Redeem Now',
    description: 'Challenge met and available to redeem locked offer',
  },
  retry: {
    id: 'retry',
    defaultMessage: 'Retry',
    description: 'Reload evaluatUserOffers',
  },
  retryMessage: {
    id: 'retryMessage',
    defaultMessage:
      'We’re having trouble showing your progress on this offer. Please refresh or check back later.',
    description: 'Message for reload button.',
  },
});
